<template>
    <div
        v-show="visible"
        class="absolute inset-0 z-30 flex items-center justify-center bg-black/40 rounded-lg pointer-events-auto"
    >
        <div class="mx-4 max-w-sm rounded-lg bg-white p-4 shadow-lg text-center">
            <i class="pi pi-lock text-primary text-2xl mb-2" />
            <p class="text-sm font-medium text-gray-800">{{ t("map_config.locked_center") }}</p>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { useStoreI18n } from "@/composables/useStoreI18n"

defineProps<{
    visible: boolean
}>()

const { t } = useStoreI18n()
</script>
